<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-flex justify-content-between align-items-center mb-3">
      <div>
        <h5 class="text-capitalize">Olá {{ account.user.name.split(' ')[0].toLowerCase() }}!</h5>
      </div>
    </div>

    <template v-if="account && account.user && account.user.plan && account.user.plan.current && account.user.plan.current.service">
      <div class="row">
        <div class="col-lg-6">
          <router-link class="text-dark" tag="a" :to="'/telemedicina'">
            <div class="card card-icon" :class="account.user.plan.current.service.telemedicina">
              <div class="card-body bg-card" :style="{ backgroundImage: `url(${require('@/assets/images/bg/telemedicina.png')})` }">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                    <path d="M15 2.013H9V9H2v6h7v6.987h6V15h7V9h-7z"></path>
                  </svg>
                </div>
                <h5 class="mt-3">Telemedicina</h5>
                <p class="m-0">Consulta rápida e eficiente com clínico geral</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </template>
  </Layout>
</template>